import { useCreateEntity, useDeleteEntity, useGetEntity } from '@abaninja/util-store';

import { createConnection, deleteConnection, getConnection } from '../connections';

export const useConnectionStore = () => ({
  ...useCreateEntity(createConnection),
  ...useGetEntity(getConnection),
  ...useDeleteEntity(deleteConnection),
});
